import { typoM } from 'components/file-cabinet-folders/styles';

export const styles = {
  iconBtn: {
    padding: 0,
    '&.with-border': {
      border: '1px solid #EDEFF7',
      borderRadius: '8px',
      width: '36px',
      height: '36px',
    },
    '&:hover': {
      background: '#fff',
    },
  },
  popover: {
    '& .MuiPopover-paper': {
      marginTop: '8px',
      padding: '4px 2px',
      borderRadius: '12px !important',
    },
    '& .MuiButtonBase-root': {
      ...typoM,
      color: '#23252f',
      textTransform: 'capitalize',
      display: 'block',
      padding: '14px 16px',
      minWidth: '174px',
      textAlign: 'left',
    },
  },
  actionBtn: {
    width: '100%',
    display: 'flex !important',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '8px',
    padding: '14px 16px',
    marginBottom: '2px',
    ...typoM,
    textTransform: 'capitalize',
    textDecoration: 'none',

    '& .MuiButton-startIcon': {
      margin: 0,
    },

    '&:hover': {
      backgroundColor: '#F2F5FF',
    },

    '&.Mui-disabled': {
      '& svg': {
        opacity: '0.4',
      },
    },

    '&.small': {
      padding: '5px 8px',
      width: '100%',

      '& svg': {
        width: '16px',
        height: '16px',
      },
    },
  },
};
